import React from 'react'

import "./about.css";
import AboutImg from "./../../assets/about.jpg";
import GedungSate from "./../../assets/gedungsate.jpeg";
import Info from "./Info";

const About = () => {
    return (
    <section className="about section" id="about">
        <h2 className="section__title">About Me</h2>
        <span className="section__subtitle">My introduction</span>

        <div className="about__container container grid">
            <img src={GedungSate} alt="" className="about__img" />
            
            <div className="about__data">
                <Info />

                <p className="about__description">
                I am a Web Developer and User Interface Designer based in <span className="about__desc-spec">Bandung, Indonesia</span>. I love building simple and clean websites that are easy to use and beautiful to look at
                </p>

                <p className="about__description">
                    I've been a big fan of <span className="about__desc-spec">programming</span> computers ever since I was a lil' booger. The process of creating something out of nothing has always been what I loved most about it.
                </p>
            </div>
        </div>
    </section>
    )
}

export default About